<swiper class="swiper-custom-navigation" [(index)]="slideIndex" [config]="swiperConfig" [class.notifications-swiper--active]="hasMultipleNotifications" [paginationColor]="restaurantType$ | async" (indexChange)="true">
  <ng-container *ngFor="let alerte of alertes; let i=index">
    <app-alerte [alerte]="alerte.alerte" [receivedAlerte]="alerte.state" (alerteDismissed)="dismissAlerte()" [showTitle]="hasMultipleNotifications"></app-alerte>
  </ng-container>
  <ng-container *ngFor="let enquete of enquetes; let i=index">
    <app-enquete [enquete]="enquete.enquete" [receivedEnquete]="enquete.state" (enqueteDismissed)="dismissEnquete($event)" [showTitle]="hasMultipleNotifications"></app-enquete>
  </ng-container>
</swiper>
